import React, { useState } from 'react';
import {
  Container,
  Heading,
  Title,
  Subtitle,
  AccordionItem,
  AccordionHeader,
  AccordionContent,
} from './Collapsible.styles';

const accordionData = [
  {
    id: 1,
    title: 'Expert Digital Marketing Services',
    content: 'We provide a comprehensive suite of digital marketing solutions, including SEO, PPC, social media management, and content creation, to help your business grow and reach a wider audience. Our strategies are data-driven and tailored to your specific goals.',
  },
  {
    id: 2,
    title: 'Transparency',
    content: 'At SRK Softwares, we believe in complete transparency. Our clients have full visibility into our processes, progress, and performance metrics. We provide regular reports and maintain open communication to ensure you are always informed.',
  },
  {
    id: 3,
    title: 'Effective Communication',
    content: 'We prioritize clear and timely communication. Our dedicated project managers and support teams are always available to answer your questions and provide updates. We use collaborative tools to ensure a seamless flow of information between our team and yours.',
  },
  {
    id: 4,
    title: 'Timely Work',
    content: 'Meeting deadlines is a cornerstone of our service. Our agile development and project management methodologies ensure that we deliver high-quality work on schedule. We respect your time and business needs, ensuring prompt and efficient delivery.',
  },
  {
    id: 5,
    title: 'Industry Research',
    content: 'Our team stays ahead of the curve by continuously conducting in-depth industry research. This allows us to implement the latest technologies, trends, and best practices, giving your business a competitive edge.',
  },
  {
    id: 6,
    title: 'Technology',
    content: 'We leverage cutting-edge technology to build robust and scalable solutions. From modern frameworks to powerful development tools, we ensure that our technology stack is aligned with industry standards and your long-term business goals.',
  },
  {
    id: 7,
    title: 'Flexibility',
    content: 'We offer flexible solutions that can be customized to fit your unique requirements and budget. Whether you need a small-scale project or a large enterprise-level solution, we can adapt our services to meet your needs.',
  },
  {
    id: 8,
    title: 'Powerful Tools',
    content: 'Our team utilizes a suite of powerful, industry-standard tools for development, design, and marketing. This allows us to work efficiently and deliver high-quality results that are both reliable and effective.',
  },
  {
    id: 9,
    title: 'Exceptional Value',
    content: 'We are committed to providing exceptional value for your investment. Our services are designed to deliver a high return, focusing on long-term results and sustainable growth for your business.',
  },
];

const Collapsible = () => {
  const [openItemId, setOpenItemId] = useState(null);

  const handleItemClick = (id) => {
    setOpenItemId(openItemId === id ? null : id);
  };

  return (
    <Container>
      <Heading>
        <Title>What Makes Us Unique?</Title>
        <Subtitle>
          At SRK Softwares, we stand out from the crowd by reinventing the way you experience technology.
          We're not just a company; we're your partners in making your digital dreams a reality.
        </Subtitle>
      </Heading>

      {accordionData.map((item) => (
        <AccordionItem key={item.id}>
          <AccordionHeader onClick={() => handleItemClick(item.id)}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ fontSize: '1.5em', marginRight: '15px' }}>
                <i className="fas fa-magic"></i>
              </span>
              <span>{item.title}</span>
            </div>
            <span>{openItemId === item.id ? '-' : '+'}</span>
          </AccordionHeader>
          {openItemId === item.id && (
            <AccordionContent>
              <p>{item.content}</p>
            </AccordionContent>
          )}
        </AccordionItem>
      ))}
    </Container>
  );
};

export default Collapsible;